import {BaseModel} from './base-model.model';

export class QueryResultApi<T extends BaseModel> {
  success: boolean;
  items: T[];
  error: string;
  meta?: QueryResultMeta;
}

export interface QueryResultMeta {
  total_count: number
}

export interface QuerySendParams {
  id: string,
  value: any,
}
